import { render, staticRenderFns } from "./RecordDialog3.vue?vue&type=template&id=38ebd7f8&scoped=true&"
import script from "./RecordDialog3.vue?vue&type=script&lang=js&"
export * from "./RecordDialog3.vue?vue&type=script&lang=js&"
import style0 from "./RecordDialog3.vue?vue&type=style&index=0&id=38ebd7f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ebd7f8",
  null
  
)

export default component.exports